import { MutationTree } from 'vuex';
import { UserState, TResource } from '@/types/store/user';

export const mutations: MutationTree<UserState> = {
  SET_ADMIN(state, isAdmin: boolean) {
    state.isAdmin = isAdmin
  },
  SET_TOKEN(state, token: string) {
    state.token = token
  },
  SET_ID(state, id: number) {
    state.id = id
  },
  SET_NAME(state, name: string) {
    state.name = name
  },
  SET_NICKNAME(state, nickname: string) {
    state.nickname = nickname
  },
  SET_AVATAR(state, avatar: string) {
    state.avatar = avatar
  },
  SET_PHONE(state, phone: string) {
    state.phone = phone
  },
  SET_STATUS(state, status: string) {
    state.status = status
  },
  SET_ROLES(state, roles: string[]) {
    state.roles = roles
  },
  SET_USERAUTHS(state, auths: TResource[]) {
    state.auths = auths
  },
  SET_USERINFO(state, userInfo: any) {
    state.userInfo = userInfo
  },
  SET_ORGID(state, orgId: string) {
    state.orgId = orgId
  }
};